import List from "@/components/list";
import "./table.scss";
import { newsetDesc } from "@/utils/common";

const letterArr = newsetDesc();

const Table = (args) => {
  const { listeners } = args;

  const deleteQuestion = listeners["deleteQuestion"] || function() {};
  const editQuestion = listeners["editQuestion"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const question = vo.row;
    const dealConf = [
      ["icon-edit", "编辑", () => editQuestion(question), ""],
      [
        "icon-delete",
        "删除",
        () => {
          deleteQuestion(vo);
        },
      ],
    ];

    return (
      <div class="deal-group btns">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Item = ({ props: { vo } }) => {
    const index = vo.$index + 1;
    const item = vo.row;
    const showOptions = [0, 1, 2].indexOf(item.questionnaireQuestionType) != -1;
    return (
      <div class="item" key={index}>
        <div class="item-top">
          
          <span class="title-content">
            <span class="must-star">{item.isMustAnswer == 1 ? "*" : ""}</span>
            <span class='content'>
              {`${index}、${item.questionTitle}`}
              {item.questionnaireQuestionType == 1 ? "（多选）" : ""}
            </span>
          </span>
          
          {showOptions ? (
          <div class="item-bottom">
            {item.options.map((item, i) => (
              <div class="option-text" key={i + item.optionTitle}>{`${letterArr[i]}、${item.optionTitle}`}</div>
            ))}
          </div>
        ) : null}
        </div>
        <Deal vo={vo} />
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "问题",
      render: (vo) => <Item vo={vo} />,
    },
    // {
    //   label: "操作",
    //   width: '90',
    //   render: (vo) => <Deal vo={vo} />,
    // },
  ];
  return (
    <List
      {...args}
      showHeader={false}
      stripe={false}
      empty-text="尚未添加任何题目，点击右上角【新增问题】进行维护"
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
